import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Image } from '@outdoor-voices/ui';
import { isMobileLarge } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { memo, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { RESIZE } from '../../../config/constants';
import css from './Two.module.scss';
import newLineToBreakTag from '../../../utils/strings/newLineToBreakTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Two = /*#__PURE__*/memo(function (_ref) {
  var blocks = _ref.blocks;

  var _useState = useState(isMobileLarge() ? 'mobile' : 'desktop'),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  useEffect(function () {
    var onResize = function onResize() {
      /* eslint-disable */
      var newType = isMobileLarge() ? "mobile" : "desktop";
      /* eslint-enable */

      if (newType === type) {
        return;
      }

      setType(newType);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [type]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: blocks.edges.map(function (_ref2, idx) {
      var _ref2$node = _ref2.node,
          cta = _ref2$node.cta,
          id = _ref2$node.id,
          image = _ref2$node.image,
          imageMobile = _ref2$node.imageMobile,
          subtitle = _ref2$node.subtitle,
          subtitleColor = _ref2$node.subtitleColor,
          title = _ref2$node.title,
          titleColor = _ref2$node.titleColor,
          url = _ref2$node.url;
      var img = type === 'mobile' && imageMobile ? imageMobile : image;
      return /*#__PURE__*/_jsxs("div", {
        className: cc([css.root, _defineProperty({}, css.second, idx === 1)]),
        children: [/*#__PURE__*/_jsx("div", {
          className: css.image,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, img), {}, {
            sizes: [320, 406]
          }))
        }), /*#__PURE__*/_jsxs("div", {
          className: css.Text,
          children: [title && /*#__PURE__*/_jsx("h2", {
            className: css.title,
            dangerouslySetInnerHTML: {
              __html: newLineToBreakTag(title)
            },
            style: {
              color: titleColor
            }
          }), subtitle && /*#__PURE__*/_jsx("h3", {
            className: css.subtitle,
            dangerouslySetInnerHTML: {
              __html: newLineToBreakTag(subtitle)
            },
            style: {
              color: subtitleColor
            }
          }), cta && url && /*#__PURE__*/_jsx("div", {
            className: css.cta,
            children: /*#__PURE__*/_jsx(Button, {
              big: true,
              href: url,
              children: cta
            })
          })]
        })]
      }, id);
    })
  });
});
Two.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({}))
  })
};